import styled from 'styled-components';

interface IProps {
  parentHeight: number;
  parentWidth: number;
  generating: boolean;
}

export const PdfBase = styled.div<IProps>`
  & > div:first-child {
    height: ${(props: IProps): string => (props.generating ? '297mm' : '100%')};
    width: ${(props: IProps): string => (props.generating ? '210mm' : '100%')};
    min-width: ${(props: IProps): string =>
      props.generating ? '210mm' : '100%'};
    transform: ${(props: IProps): string =>
      props.generating
        ? props.parentHeight / 1122 > 0
          ? `scale(${props.parentHeight / 1122})`
          : 'scale(1.0)'
        : 'none'};
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  padding: ${(props: IProps): string =>
    props.generating ? '0px' : '20px 5% 20px 5%'};
  @media (max-width: 990px) {
    padding: ${(props: IProps): string =>
      props.generating ? '0px' : '10px 10px 60px 10px'};
  }
`;
